<template>
    <div v-if="copyNode">
        <label for="option-title">Option Title:</label>
        <b-form-input
            id="option-title"
            v-model="copyNode.title"
            :state="nameState"
            aria-describedby="input-live-help input-live-feedback"
            placeholder="Enter your name"
            trim/>
        <b-form-invalid-feedback id="input-live-feedback">
            Enter at least 3 letters
        </b-form-invalid-feedback>

        <label for="option-short-name" class="mt-3">Short Name:</label>
        <b-form-input
            id="option-short-name"
            v-model="copyNode.shortName"
            placeholder="Enter Short name"
            trim />

        <label for="item-price" class="mt-3">Price:</label>
        <b-form-input
            id="item-price"
            type="number"
            min="0"
            step="0.01"
            v-model="copyNodePrice"
            placeholder="Enter Price"
            trim/>
        <b-row class="mt-2">
            <b-col md="6">
                <b-form-checkbox
                    id="trackable"
                    v-model="copyNode.trackable"
                    name="trackable"
                    value="true"
                    unchecked-value="false">
                    Trackable
                </b-form-checkbox>
            </b-col>
            <b-col md="6">
                <b-form-checkbox
                    id="preselect"
                    v-model="copyNode.preselect"
                    name="preselect"
                    value="true"
                    unchecked-value="false">
                    Preselect
                </b-form-checkbox>
            </b-col>
        </b-row>
        <b-button size="sm" 
                  class="my-2 float-right"
                  variant="outline-primary"
                  @click="onSubmit"
                  :disabled="!nameState">Submit</b-button>
        <b-button size="sm" 
                  class="m-2 float-right"
                  variant="outline-danger"
                  @click="$emit('onCancel')">Cancel</b-button>
    </div>
</template>

<script>
export default {
    name : 'TreeMenuOption',
    props : ['node'],
    data() { return { copyNode : null } },
    computed : {
        nameState() {
            return this.copyNode && this.copyNode.title && this.copyNode.title.length > 2 ? true : false
        },
        copyNodePrice : {
            get() {
               return this.copyNode.price / 100.0
            },
            set(newVale) {
                // SJC: I changed this from floor to round.  floors was a problem if you tried to enter 10.2 --> changted to 10.19
                this.copyNode.price = Math.round(newVale * 100.0)
            }
        }
    },
    watch : {
        node : {
            deep: true,
            handler(newValue) {
                if(newValue.method === "addChild") {
                    this.copyNode = { title : "" , price : 0 }
                } else {
                    this.copyNode = this.$deepCopy(newValue.node);
                }
            }
        }
    },
    created() { 
        if(this.node.method === "addChild") {
            this.copyNode = { title : "" , price : 0  }
        } else {
            this.copyNode = this.$deepCopy(this.node.node); 
        }
    },
    destroyed() { },
    methods: { 
        onSubmit() {
            this.$emit("onSubmit", this.copyNode)
        }
    },
}
</script>

<style scoped lang="scss">

</style>